/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterUSmall = createReactComponent("letter-u-small", "IconLetterUSmall", [
  ["path", { d: "M10 8v6a2 2 0 1 0 4 0v-6", key: "svg-0" }]
]);

export { IconLetterUSmall as default };
//# sourceMappingURL=IconLetterUSmall.js.map
